var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertTriangleOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "-0.7366 -1.9979 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2634 7.50414V11.5041M11.2634 15.5041H11.2734M9.87872 2.39586L1.65383 16.6025C1.19763 17.3905 0.969524 17.7845 1.00324 18.1078C1.03264 18.3899 1.18041 18.6462 1.40977 18.8129C1.67273 19.0041 2.12799 19.0041 3.03852 19.0041H19.4883C20.3988 19.0041 20.8541 19.0041 21.117 18.8129C21.3464 18.6462 21.4942 18.3899 21.5236 18.1078C21.5573 17.7845 21.3292 17.3905 20.873 16.6025L12.6481 2.39586C12.1935 1.61069 11.9662 1.21811 11.6697 1.08626C11.411 0.971247 11.1158 0.971247 10.8571 1.08626C10.5606 1.21811 10.3333 1.6107 9.87872 2.39586Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertTriangleOutline);
export default __webpack_public_path__ + "static/media/alert-triangle-outline.23bab12b5311751c5ab8b43403e22346.svg";
export { ForwardRef as ReactComponent };